import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Row, Col, ButtonToolbar, Button, Input} from 'react-bootstrap'
import cx from 'classnames'
import {errorStatus} from '../../core/redux/status'
import {connectForm, controlledField, selectField} from '../../core/redux/form'
import Card from '../../core/components/Card'
import RadioToggle from '../../core/components/RadioToggle'
import LoaderButton from '../../core/components/LoaderButton'
import {QUALIFY_TICKET_CLAIM_CMD_UPDATED, sendQualifyTicketClaimCmd, loadTicketClaim} from '../actions'
import {QualifyTicketClaimCmd} from '../models'
import i18n from '../i18n'
import style from './QualifyTicketClaimCard.less'

class QualifyTicketClaimCard extends Component {
    static propTypes = {
    }

    _sendCmd() {
        const {dispatch} = this.props

        return dispatch(sendQualifyTicketClaimCmd()).then(() => {
            return dispatch(loadTicketClaim())
        })
    }

    render() {
        const {dispatch, form, cmd, reference, ...others} = this.props

        const header = (
            <h5>{i18n.qualifyTicketClaim}</h5>
        )

        const treatmentPriorityLabel = (treatmentPriority) => (
            <span>
                <span>{treatmentPriority.label}</span>
                <small>{treatmentPriority.info}</small>
            </span>
        )

        return (
            <Card
                header={header}
                {...others}>
                <div className={style.defaultContent}>
                    <form>
                        <Input
                            type='select'
                            {...selectField(form.ticketClaimCategoryUid())}>
                            <option value=''>{i18n.ticketClaimCategory} ...</option>
                            {reference.ticketClaimCategory.map((ticketClaimCategory) => (
                                <option
                                    key={ticketClaimCategory.uid}
                                    value={ticketClaimCategory.uid}>
                                    {ticketClaimCategory.label}
                                </option>
                            ))}
                        </Input>
                        {reference.treatmentPriority.length > 0 && (
                            <div>
                                <h5>{i18n.treatmentPriority}</h5>
                                <RadioToggle
                                    {...form.treatmentPriorityUid()}>
                                    {reference.treatmentPriority.map((treatmentPriority) => (
                                        <Input
                                            key={treatmentPriority.uid}
                                            type='radio'
                                            label={treatmentPriorityLabel(treatmentPriority)}
                                            value={treatmentPriority.uid} />
                                    ))}
                                </RadioToggle>
                            </div>
                        )}
                        <Input
                            type='textarea'
                            rows={4}
                            placeholder={i18n.comment + ' *'}
                            {...controlledField(form.comment())} />
                    </form>
                    <ButtonToolbar>
                        <LoaderButton
                            bsStyle='primary'
                            bsSize='large'
                            className={cx({disabled: !form.isValid()})}
                            onClick={() => form.validate() && this._sendCmd() || dispatch(errorStatus(i18n.formInvalid))}>
                            {i18n.validate}
                        </LoaderButton>
                    </ButtonToolbar>
                </div>
            </Card>
        )
    }
}

QualifyTicketClaimCard = connectForm({
    target: 'cmd',
    schema: QualifyTicketClaimCmd.schema,
    action: QUALIFY_TICKET_CLAIM_CMD_UPDATED
})(QualifyTicketClaimCard)

QualifyTicketClaimCard = connect((state) => ({
    cmd: state.claim.qualifyTicketClaimCmd,
    reference: state.reference.ticketClaimRef
}))(QualifyTicketClaimCard)

export default QualifyTicketClaimCard


// WEBPACK FOOTER //
// ./lib/claim/components/QualifyTicketClaimCard.js